import React, { useMemo, useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Tab, Tabs } from 'transfix-ui/components/'
import { TopNav } from 'transfix-ui/components/TopNav'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useQueryParams, BooleanParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DedicatedLanesContractsPage } from 'apps/fleet-planner/pages/dedicated-lanes/DedicatedLanesContractsPage'
import { DedicatedLanesFindOpportunitiesSubpage } from 'apps/fleet-planner/pages/dedicated-lanes/DedicatedLanesFindOpportunitiesSubpage'

const useDedicatedLanesMainPageStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  subtitle: {
    color: brandColors.coolGray5,
  },
  topNav: {
    marginBottom: theme.spacing(2),
  },
  tabs: {
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(10),
    },
  },
}))

interface IUrlProp {
  tab?: string
}

enum ITabs {
  search = 'Find Opportunities',
  contracts = 'My Dedicated Lanes',
}

const DedicatedLanesMainPageHeader = () => {
  const classes = useDedicatedLanesMainPageStyles()
  const { isMobile } = useBreakpointContext()

  return isMobile ? (
    <TopNav title='Dedicated Freight' className='topNav' />
  ) : (
    <Box className={classes.root}>
      <Typography variant='h2'>Dedicated Freight</Typography>
      <Typography variant='subtitle1' className={classes.subtitle}>
        Find new contract opportunities and manage your contracts
      </Typography>
    </Box>
  )
}

export const DedicatedLanesMainPage = () => {
  const history = useHistory()
  const params = useParams<IUrlProp>()
  const classes = useDedicatedLanesMainPageStyles()
  const [{ mobileApp }] = useQueryParams({ mobileApp: BooleanParam })

  const tabChangeHandler = useCallback(
    (newValue: string) => {
      const mobileAppQueryParam = mobileApp ? '?mobileApp=1' : ''
      if (newValue === ITabs.search) {
        history.push(`/dedicated-lanes/search${mobileAppQueryParam}`)
      } else {
        history.push(`/dedicated-lanes/contracts${mobileAppQueryParam}`)
      }
    },
    [history, mobileApp]
  )

  const currentTab = useMemo(() => (params.tab === 'search' ? ITabs.search : ITabs.contracts), [
    params.tab,
  ])

  return (
    <div>
      {!mobileApp ? <DedicatedLanesMainPageHeader /> : null}
      <div className={!mobileApp ? classes.tabs : undefined}>
        <Tabs value={currentTab} onChange={tabChangeHandler}>
          <Tab label={ITabs.search}>
            <DedicatedLanesFindOpportunitiesSubpage />
          </Tab>
          <Tab label={ITabs.contracts}>
            <DedicatedLanesContractsPage />
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
